import { Grid, Drawer, Divider, Button, Box } from '@mui/material';
import EditButton from '../EditButton/EditButton';
import { FC, useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { SettingsInformation } from "../../utils/account.types";
import SettingDialogForm from "../Settings/SettingDialogForm";
import { fetchAccountById, updateAccount } from "../../store/accountThunk";

const Subscription: FC = () => {
  const dispatch = useAppDispatch();
  const [accountBasicInf, setaccountBasicInf] = useState<SettingsInformation>();
  const [open, setOpen] = useState(false);

  const accountDetails = useAppSelector(state => state.account.accountDetails);

  const cardClicked = () => {
    handleOpen();
  }

  const getData = (data: any): SettingsInformation => {
    const { subscription, verifiedStatus } = data;
    return {
      'subscription': { value: subscription?.plan, title: 'Plan' },
      'verifiedStatus': { value: verifiedStatus === 'false' ? 'No' : 'Yes', title: 'Verified Status' },
    };
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const onSubmit = async (data: any) => {
    try {
      const responseData: any = await dispatch(updateAccount({
        id: accountDetails._id,
        accountPayload: data,
      }));

      if (responseData && responseData?.status === 200) {
        dispatch(fetchAccountById(accountDetails._id));
        handleClose();
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  // Sync subscription / verified status from account details
  useEffect(() => {
    let active = true;
    try {
      if (active && Object.keys(accountDetails).length) {
        setaccountBasicInf(getData(accountDetails));
      }
    } catch (error: any) {
      console.log('Subscription catch block called');
    }
    return () => { active = false; };
  }, [accountDetails]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10, height: '100%' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, m: '-10px -15px 12px', px: '15px', py: 0.5, bgcolor: '#e9ecf1', borderBottom: '1px solid #dcdcdc', borderRadius: '8px 8px 0 0' }}>
            <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, margin: 0 }}>Subscription</h5>
            <EditButton size='small' onClick={cardClicked} />
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.subscription.title}</h5>
              <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{accountBasicInf?.subscription.value}</h5>
            </Grid>
            <Grid item xs={6}>
              <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.verifiedStatus.title}</h5>
              <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{accountBasicInf?.verifiedStatus.value}</h5>
            </Grid>
          </Grid>
          <Drawer
            anchor="right"
            open={open}
          >
            {<SettingDialogForm title='Update Account' open={open} data={accountDetails} onClose={handleClose} onSubmit={onSubmit} />}
          </Drawer>
        </div>
      </Grid>
    </Grid>
  );
};

export default Subscription;
